module.exports = __webpack_public_path__ + "static/media/hardware-repair.f85b7ce3.svg";